import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useState } from 'react';
import { useMutation, useNotify, useRefresh } from 'react-admin';
import { useDispatch } from 'react-redux';
import { USERS } from '../../../../providers/resources';
import { User } from '../../../../utils/types';
import {
    getCodeFromViolationMessage,
    getViolations,
    ValidationError,
    ViolationResolved,
} from '../../../../utils/validations/parseValidations';
import GlobalForm from '../../../forms';
import ButtonsBlockForm from '../../../forms/buttonsBlock';
import { selectUser } from '../../../../redux/actions/users';

interface DeleteFormProps {
    open: boolean;
    handleClose: () => void;
    selected: User | undefined;
}

const DeleteForm = ({ open, handleClose, selected }: DeleteFormProps) => {
    const [_open, setOpen] = useState<boolean>(open);
    const dispatch = useDispatch();
    const notify = useNotify();
    const refresh = useRefresh();

    const _handleClose = () => {
        setOpen(false);
        handleClose();
    };
    const [remove, { loading }] = useMutation({
        type: 'delete',
        resource: USERS,
    });

    const deleteFn = () => {
        remove(
            {
                payload: {
                    id: selected?.id,
                },
            },
            {
                onSuccess: () => {
                    dispatch(selectUser.fn(null));
                    notify('app.users.delete.success', 'info');
                    _handleClose();
                    refresh();
                },
                onFailure: (...args: unknown[]) => {
                    const violations: ViolationResolved[] = getViolations(args[0] as ValidationError);

                    if (violations && violations.length > 0) {
                        const violation = violations[0];
                        notify(`${getCodeFromViolationMessage(violation?.message)}`, 'warning');
                    } else {
                        notify('app.errors.server', 'warning');
                    }
                    _handleClose();
                },
            }
        );
    };

    return (
        <Dialog open={_open} onClose={_handleClose} aria-labelledby='form-dialog-title' fullWidth maxWidth={'md'}>
            <DialogContent>
                <GlobalForm
                    title={'app.users.delete.title'}
                    subtitle={'app.users.delete.subtitle'}
                    subtitleTranslateOption={{ username: `${selected?.firstName} ${selected?.lastName}` }}
                    titleIcon={<DeleteIcon color={'secondary'} />}
                />
                <ButtonsBlockForm
                    disableValidButton={loading || !selected}
                    onCancel={_handleClose}
                    validButtonIsSubmitType={false}
                    onValid={deleteFn}
                    labelValidButton={'app.delete'}
                />
            </DialogContent>
        </Dialog>
    );
};
export default DeleteForm;
